const rlvServices = {
    PORTEADOR_EDU: "03-PORTEADOR-EDU",
    PORTEADOR_TER: "04-PORTEADOR-TER",
    REGULAR: "05-REGULAR",
    INT: "09-INT",
    IDENT_TEMPRANA: "16-IDENT TEMPRANA",
    CONSEJERIA_REAH: "17-CONSEJERÍA REAH",
    ORIE_Y_MOVILIDAD: "18-ORIE Y MOVILIDAD",
    MEDICOS: "19-MEDICOS",
    ENFERMERIA: "20-ENFERMERIA",
    TS: "21-TS",
    PARENT_TRAINING: "23-PARENT TRAINING",
    T1: "24-T1"
  };
  
export default rlvServices;
  